import { type ReactNode } from 'react';

interface TokenProps {
    value: string;
    variableName: string;
    uses: string;
    example?: ReactNode;
}

export const Token = ({ value, variableName, uses, example = undefined }: TokenProps) => (
    <div className="sds_example__container">
        <div style={{ width: '25%' }} className="sds_token__text__name">
            {variableName}
        </div>
        <div style={{ width: '25%' }} className="sds_token__example">
            {example}
        </div>
        <div style={{ width: '25%' }} className="sds_token__text__value">
            {value}
        </div>
        <div style={{ width: '25%' }} className="sds_token__text__use">
            {uses}
        </div>
    </div>
);
